/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { participantAPI } from '../api/participant';
import { Dispatch } from '../redux';

export function fetchCurrentTask() {
  return async (dispatch: Dispatch) => {
    const { task: currentTask } = await participantAPI.tasks.getCurrentTask();
    dispatch({ type: 'SET_CURRENT_TASK', payload: currentTask });
  };
}

export function submitCurrentTask(nextTask: any) {
  return (dispatch: Dispatch) => {
    dispatch({ type: 'SET_CURRENT_TASK', payload: nextTask });
  };
}

export function backToUserSelect() {
  return async (dispatch: Dispatch) => {
    const { task: nextTask } = await participantAPI.tasks.backToUserSelect();
    dispatch({ type: 'SET_CURRENT_TASK', payload: nextTask });
  };
}
